<div class="settings-container">
    <div class="filter-buttons">
        <button mat-flat-button color="primary" (click)="toggleFilters()">
            <mat-icon>tune</mat-icon>Filter {{ showFilters ? 'ausblenden' : 'anzeigen' }}
        </button>
        <button mat-raised-button color="warn" (click)="resetFilters()" matBadge="{{ activeFilterCount }}" matBadgePosition="above after" [disabled]="activeFilterCount === 0">
            <mat-icon>clear</mat-icon>
            Filter zurücksetzen
        </button>
    </div>
    <mat-button-toggle-group class="review-mode-toggle" [value]="selectedMode" (change)="onReviewModeChange($event.value)" aria-label="Review Mode">
        <mat-button-toggle [value]="ReviewMode.Select">Auswählen</mat-button-toggle>
        <mat-button-toggle [value]="ReviewMode.Order">Ordnen</mat-button-toggle>
    </mat-button-toggle-group>
</div>

  
<!-- Filteroptionen -->
@if(showFilters) {
    <div class="filter-container">
        <div class="filter-option">
            <h3>Name</h3>
            <hr />
            <mat-form-field >
                <mat-label>Filter nach Name</mat-label>
                <input matInput [(ngModel)]="filter.name" (ngModelChange)="applyFilter()" placeholder="Name" />
            </mat-form-field>
        </div>
        <div class="filter-option">
            <h3>Bewertung</h3>
            <hr />
            @for(rating of ratingOptions; let index = $index; track $index) {
                <div class="filter-rating-container">
                    <mat-checkbox
                    [checked]="filter.rating[rating]"
                    (change)="onFilterRatingChange(rating, $event.checked)">
                        <div class="filter-stars">
                            @for (star of ratingOptions; let index = $index; track $index) {
                                <mat-icon class="{{ index < rating ? 'filled-rating-stars' : 'empty-rating-stars' }}">star</mat-icon>
                            }
                        </div>     
                    </mat-checkbox>
                </div>
            }
        </div>
        <div class="filter-option">
            <h3>Sichtbarkeit</h3>
            <hr />
            <mat-form-field>
                <mat-label>Filter nach Sichtbarkeit</mat-label>
                <mat-select [(ngModel)]="filter.show" (ngModelChange)="applyFilter()" panelClass="admin-theme">
                    <mat-option [value]="null">Alle</mat-option>
                    <mat-option [value]="true">
                        <mat-icon class="checkmark">check_circle</mat-icon> Sichtbar
                    </mat-option>
                    <mat-option [value]="false">
                        <mat-icon class="cross">cancel</mat-icon> Versteckt
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
}

<mat-divider></mat-divider>

  
<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let review"> {{review.name}} </td>
    </ng-container>

    <ng-container matColumnDef="rating">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Bewertung </th>
        <td mat-cell *matCellDef="let review"> 
                @for (star of ratingOptions; let index = $index; track $index) {
                    <mat-icon class="{{ index < review.rating ? 'filled-rating-stars' : 'empty-rating-stars' }}">star</mat-icon>
                }
        </td>
    </ng-container>

    <ng-container matColumnDef="text">
        <th mat-header-cell *matHeaderCellDef> Text </th>
        <td mat-cell *matCellDef="let review" class="cell-content">
            <div >
                <p #ellipsisRef ellipsis (ellipsis-change)="onTextTruncated($event, review)" [ngClass]="{ 'line-clamp': !review.expanded }">
                    {{review.text}} 
                </p>
                @if(review.isTruncated && !review.expanded){
                    <span class="show-more-button"  (click)="toggleShowMore(review)">Mehr anzeigen</span>
                } @else if(review.expanded) {
                    <span class="show-more-button" (click)="toggleShowMore(review)">Weniger anzeigen</span>
                }
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="show">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sichtbar </th>
        <td mat-cell *matCellDef="let review"> 
            <div class="review-toggle">
                <mat-slide-toggle [checked]="review.show" (change)="updateReviewShow($event.checked, review.id)" color="primary"></mat-slide-toggle>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">Keine passenden Einträge gefunden</td>
    </tr>
</table>
<mat-paginator [pageSizeOptions]="[5, 10, 25]" aria-label="Select page of users" showFirstLastButtons="true" [selectConfig]=adminTheme></mat-paginator>


